<!--
 * @Description: 著作权人信息
 * @Author: ll
 * @Date: 2021-9-7 16:53:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <a-modal class="ownerInfo" :visible="ownerVisible" title="著作权人信息" @ok="handleOk" @cancel="cancel" width="700px">
    <a-form-model-item label="著作权人类型" class="cr-mb-2" required>
      <a-radio-group :value="category" class="cr-mt-1 cr-pl-3" @change="radioChange">
        <a-radio value="企业单位">企业单位</a-radio>
        <a-radio value="事业单位">事业单位</a-radio>
        <a-radio value="分公司">分公司</a-radio>
        <a-radio value="自然人">自然人</a-radio>
        <a-radio value="未成年人">未成年人</a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model ref="form1" key="form1" :model="formData1" :rules="rules1" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="category === '企业单位'" labelAlign="left">
      <a-form-model-item label="企业名称" prop="ownerName">
        <a-select v-model="formData1.ownerName" show-search :autoClearSearchValue="false" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="optionLoading ? undefined : null" @search="handleSearch" @focus="handleFocus" @change="handleChange" placeholder="请输入与营业执照一直的公司名称">
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option :value="item" v-for="item in companyList" :key="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="社会信用代码" prop="socialCreditCode">
        <a-input v-model="formData1.socialCreditCode" placeholder="请输入企业统一社会信用代码" :disabled="codeDisabled1" />
      </a-form-model-item>

      <a-form-model-item label="公司成立日期" prop="companyFoundDate" placeholder="请选择公司成立日期">
        <a-date-picker v-model="formData1.companyFoundDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" :disabled="dateDisabled1" />
      </a-form-model-item>

      <a-form-model-item label="证明文件" prop="certified">
        <upload-img class="cr-mr-2" v-model="formData1.certified" />
        <example :url="exampleCard1"></example>
      </a-form-model-item>

      <a-form-model-item label="前期开发说明" prop="developInstruction" v-if="lt3Month">
        <upload-file class="cr-mr-1" upText="前期开发说明" v-model="formData1.developInstruction" />
        <a :href="link6">下载模版</a>
      </a-form-model-item>

      <a-form-model-item label="技术员身份证明" prop="technicianCertified" v-if="lt3Month">
        <div class="tech-wrapper">
          <div class="img-wrapper cr-mr-2">
            <upload-img v-for="(item, index) in imagesArr" :key="index" upText="身份证扫描件" v-model="item.url" />
          </div>
          <example :url="exampleId"></example>
        </div>
      </a-form-model-item>

      <a-form-model-item class="cr-jc-center cr-text-center" v-if="lt3Month">
        <a-button type="primary" hcrl-type="submit" @click="onAddBtn"> <a-icon type="plus" class="cr-fs-md" /> 添加技术人员 </a-button>
      </a-form-model-item>
    </a-form-model>

    <a-form-model ref="form2" key="form2" :model="formData2" :rules="rules2" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="category === '事业单位'" labelAlign="left">
      <a-form-model-item label="单位名称" prop="ownerName">
        <a-select v-model="formData2.ownerName" show-search :autoClearSearchValue="false" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="optionLoading ? undefined : null" @search="handleSearch2" @focus="handleFocus2" @change="handleChange2" placeholder="请输入事业单位名称">
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option :value="item" v-for="item in companyList" :key="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="社会信用代码" prop="socialCreditCode">
        <a-input v-model="formData2.socialCreditCode" placeholder="请输入统一社会信用代码" :disabled="codeDisabled2" />
      </a-form-model-item>

      <a-form-model-item label="有效期" placeholder="请选择日期" prop="validPeriodStart">
        <a-range-picker v-model="timeArr" @change="pickerChange" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
      </a-form-model-item>

      <a-form-model-item label="证明文件" prop="certified">
        <upload-img class="cr-mr-2" upText="事业单位法人证书" v-model="formData2.certified" />
        <example :url="exampleCard2"></example>
      </a-form-model-item>
    </a-form-model>

    <a-form-model ref="form3" key="form3" :model="formData3" :rules="rules3" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="category === '分公司'" labelAlign="left">
      <a-form-model-item label="企业名称" prop="ownerName">
        <a-select v-model="formData3.ownerName" show-search :autoClearSearchValue="false" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="optionLoading ? undefined : null" @search="handleSearch3" @focus="handleFocus3" @change="handleChange3" placeholder="请输入与营业执照一致的公司名称">
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option :value="item" v-for="item in companyList" :key="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="社会信用代码" prop="socialCreditCode">
        <a-input v-model="formData3.socialCreditCode" placeholder="请输入企业统一社会信用代码" :disabled="codeDisabled3" />
      </a-form-model-item>

      <a-form-model-item label="公司成立日期" prop="companyFoundDate" placeholder="请选择公司成立日期">
        <a-date-picker v-model="formData3.companyFoundDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" :disabled="dateDisabled3" />
      </a-form-model-item>

      <a-form-model-item label="分公司营业执照" class="cr-flex" prop="branchBusinessLicense">
        <upload-img class="cr-mr-2" upText="营业执照副本扫描件" v-model="formData3.branchBusinessLicense" />
        <example :url="exampleCard3"></example>
      </a-form-model-item>

      <a-form-model-item label="上级单位营业执照" prop="superiorBusinessLicense">
        <upload-img class="cr-mr-2" upText="营业执照副本扫描件" v-model="formData3.superiorBusinessLicense" />
        <example :url="exampleCard1"></example>
      </a-form-model-item>

      <a-form-model-item label="上级单位法人证明" prop="legalPersonsCretified">
        <upload-file class="cr-mr-2" upText="上级单位法人证明" v-model="formData3.legalPersonsCretified" />
        <a :href="link8">下载模版</a>
      </a-form-model-item>
    </a-form-model>

    <a-form-model ref="form4" key="form4" :model="formData4" :rules="rules4" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="category === '自然人'" labelAlign="left">
      <a-form-model-item label="个人姓名" prop="ownerName">
        <a-input v-model="formData4.ownerName" placeholder="请输入个人姓名" />
      </a-form-model-item>

      <a-form-model-item label="身份证号码" prop="idCard">
        <a-input v-model="formData4.idCard" placeholder="请输入身份证号码" />
      </a-form-model-item>

      <a-form-model-item label="身份证明" prop="identityIdCardCertified">
        <upload-img class="cr-mr-2" upText="身份证扫描件" v-model="formData4.identityIdCardCertified" />
        <example :url="exampleId"></example>
      </a-form-model-item>
    </a-form-model>

    <a-form-model ref="form5" key="form5" :model="formData5" :rules="rules5" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="category === '未成年人'" labelAlign="left">
      <a-form-model-item label="个人姓名" prop="ownerName">
        <a-input v-model="formData5.ownerName" placeholder="请输入个人姓名" />
      </a-form-model-item>

      <a-form-model-item label="身份证号码" prop="idCard">
        <a-input v-model="formData5.idCard" placeholder="请输入身份证号码" />
      </a-form-model-item>

      <a-form-model-item label="身份证明" prop="identityIdCardCertified">
        <upload-img class="cr-mr-2" upText="身份证扫描件" v-model="formData5.identityIdCardCertified" />
        <example :url="exampleId"></example>
      </a-form-model-item>

      <a-form-model-item label="监护人证明" prop="guardianSignCertified">
        <upload-file class="cr-mr-1" upText="监护人证明<br/>（需监护人签字）" v-model="formData5.guardianSignCertified" />
        <a :href="link9">下载模版</a>
      </a-form-model-item>

      <a-form-model-item label="监护人证明" prop="guardianIdCardCretified">
        <upload-img class="cr-mr-2" upText="身份证复印件<br/>（需监护人签字）" v-model="formData5.guardianIdCardCretified" />
        <example :url="exampleId"></example>
      </a-form-model-item>

      <a-form-model-item label="户口证明" required>
        <a-form-model-item prop="hukouCertifiedApplicant">
          <upload-img class="cr-mr-2" upText="申请人户口本所在页" v-model="formData5.hukouCertifiedApplicant" />
        </a-form-model-item>
        <a-form-model-item prop="hukouCertifiedGuardian">
          <upload-img class="cr-mr-2" upText="监护人户口本所在页" v-model="formData5.hukouCertifiedGuardian" />
        </a-form-model-item>
        <a-form-model-item prop="hukouCertifiedHomePage">
          <upload-img upText="户口本主页" v-model="formData5.hukouCertifiedHomePage" />
        </a-form-model-item>
      </a-form-model-item>
    </a-form-model>

    <cr-loading :loading="loading"></cr-loading>

    <preview-img :url="previewUrl" :show.sync="showPreview"></preview-img>
  </a-modal>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import UploadImg from '@/components/common/UploadImg'
import UploadFile from '@/components/common/UploadFile'
import { rules1, rules2, rules3, rules4, rules5, FormTemplate } from './baseForm'
import { getCompanyList, getCompanyDetail } from '@/api/caseDetail'
import moment from 'moment'
import { link6, link8, link9 } from './templateUrl'
import exampleId from '@/assets/images/example-id.png'
import exampleCard1 from '@/assets/images/example-card.png'
import exampleCard2 from '@/assets/images/example-card-2.png'
import exampleCard3 from '@/assets/images/example-card-3.png'

export default {
  props: {
    ownerVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let formData1 = new FormTemplate('企业单位')
    let formData2 = new FormTemplate('事业单位')
    let formData3 = new FormTemplate('分公司')
    let formData4 = new FormTemplate('自然人')
    let formData5 = new FormTemplate('未成年人')
    return {
      exampleId,
      exampleCard1,
      exampleCard2,
      exampleCard3,
      link6, // 前期开发说明
      link8, // 上级单位法人证明
      link9, // 监护人证明
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      category: '企业单位',
      lt3Month: false, // 是否超过三个月
      optionLoading: false,
      companyList: [],
      formData1,
      formData2,
      formData3,
      formData4,
      formData5,
      rules1,
      rules2,
      rules3,
      rules4,
      rules5,
      isAdd: true, // 是否是添加状态
      codeDisabled1: false,
      dateDisabled1: false,
      codeDisabled2: false,
      codeDisabled3: false,
      dateDisabled3: false,
      loading: false,
      timeArr: [], //表单2有效期
      imagesArr: [{ url: '' }], //表单1 多个技术人员
      showPreview: false,
      previewUrl: ''
    }
  },
  created() {
    let currentFormData = JSON.parse(sessionStorage.getItem('currentFormData')) // 若有值，代表编辑状态
    if (currentFormData) {
      // 编辑状态
      this.isAdd = false
      let category = currentFormData.category
      this.category = category
      switch (category) {
        case '企业单位':
          this.formData1 = currentFormData
          let technicianCertified = currentFormData.technicianCertified

          if (technicianCertified.length) {
            let images = []
            technicianCertified.forEach((item) => {
              let obj = { url: '' }
              obj.url = item
              images.push(obj)
            })
            this.imagesArr = images
          }

          break
        case '事业单位':
          this.formData2 = currentFormData
          this.timeArr = [currentFormData.validPeriodStart, currentFormData.validPeriodEnd]
          break
        case '分公司':
          this.formData3 = currentFormData
          break
        case '自然人':
          this.formData4 = currentFormData
          break
        case '未成年人':
          this.formData5 = currentFormData
          break
      }
    }
  },
  components: {
    UploadImg,
    UploadFile
  },
  methods: {
    onPreview(url) {
      this.previewUrl = url
      this.showPreview = true
    },
    // 表单1公司输入框输入时
    handleSearch(value) {
      this.optionLoading = true
      this.formData1.ownerName = value
      let data = {
        name: value
      }
      getCompanyList(data)
        .then((res) => {
          this.optionLoading = false
          if (res.data) this.companyList = [...new Set(res.data)]
        })
        .catch((err) => console.log(err))
    },
    // 表单1聚焦企业名称输入框 清除以往内容
    handleFocus() {
      // this.formData1.ownerName = undefined
      // this.formData1.socialCreditCode = ''
      // this.formData1.companyFoundDate = ''
      // this.companyList = []
      // this.codeDisabled1 = false
      // this.dateDisabled1 = false
    },
    // 表单1查询企业详情
    async handleChange(val) {
      this.loading = true
      const res = await getCompanyDetail({ companyName: val })
      this.loading = false
      if (res.data.creditCode) {
        this.formData1.socialCreditCode = res.data.creditCode
        this.codeDisabled1 = true
      }
      if (res.data.estiblishTime) {
        this.formData1.companyFoundDate = moment(parseInt(res.data.estiblishTime)).format('YYYY-MM-DD')
        this.dateDisabled1 = true
      }
      this.$nextTick(() => {
        this.$refs.form1.clearValidate(['socialCreditCode', 'companyFoundDate'])
      })
    },
    // 表单2公司输入框输入时
    handleSearch2(value) {
      this.optionLoading = true
      this.formData2.ownerName = value
      let data = {
        name: value
      }
      getCompanyList(data)
        .then((res) => {
          this.optionLoading = false
          if (res.data) this.companyList = [...new Set(res.data)]
        })
        .catch((err) => console.log(err))
    },
    // 表单2聚焦企业名称输入框 清除以往内容
    handleFocus2() {
      // this.formData2.ownerName = undefined
      // this.formData2.socialCreditCode = ''
      // this.companyList = []
      // this.codeDisabled2 = false
    },
    // 表单2查询企业详情
    async handleChange2(val) {
      this.loading = true
      const res = await getCompanyDetail({ companyName: val })
      this.loading = false
      if (res.data.creditCode) {
        this.formData2.socialCreditCode = res.data.creditCode
        this.codeDisabled2 = true
      }
      this.$nextTick(() => {
        this.$refs.form2.clearValidate(['socialCreditCode'])
      })
    },
    // 表单3公司输入框输入时
    handleSearch3(value) {
      this.optionLoading = true
      this.formData3.ownerName = value
      let data = {
        name: value
      }
      getCompanyList(data)
        .then((res) => {
          this.optionLoading = false
          if (res.data) this.companyList = [...new Set(res.data)]
        })
        .catch((err) => console.log(err))
    },
    // 表单3聚焦企业名称输入框 清除以往内容
    handleFocus3() {
      // this.formData3.ownerName = undefined
      // this.formData3.socialCreditCode = ''
      // this.formData3.companyFoundDate = ''
      // this.companyList = []
      // this.codeDisabled3 = false
      // this.dateDisabled3 = false
    },
    // 表单3查询企业详情
    async handleChange3(val) {
      this.loading = true
      const res = await getCompanyDetail({ companyName: val })
      this.loading = false
      if (res.data.creditCode) {
        this.formData3.socialCreditCode = res.data.creditCode
        this.codeDisabled3 = true
      }
      if (res.data.estiblishTime) {
        this.formData3.companyFoundDate = moment(parseInt(res.data.estiblishTime)).format('YYYY-MM-DD')
        this.dateDisabled3 = true
      }
    },
    // 时间段选择
    pickerChange(value) {
      this.formData2.validPeriodStart = value[0]
      this.formData2.validPeriodEnd = value[1]
    },
    onAddBtn() {
      this.imagesArr.push({ url: '' })
    },
    handleOk() {
      let _this = this
      switch (this.category) {
        case '企业单位':
          _this.$refs.form1.validate((valid) => {
            if (valid) {
              if (this.isAdd) {
                this.formData1.uuid = uuidv4()
                this.$emit('saveData', this.formData1)
                this.$emit('update:ownerVisible', false)
              } else {
                this.$emit('updateData', this.formData1)
                this.$emit('update:ownerVisible', false)
              }
            } else {
              console.log('表单1验证不通过')
            }
          })
          break
        case '事业单位':
          _this.$refs.form2.validate((valid) => {
            if (valid) {
              if (this.isAdd) {
                this.formData2.uuid = uuidv4()
                this.$emit('saveData', this.formData2)
                this.$emit('update:ownerVisible', false)
              } else {
                this.$emit('updateData', this.formData2)
                this.$emit('update:ownerVisible', false)
              }
            } else {
              console.log('表单2验证不通过')
            }
          })
          break
        case '分公司':
          _this.$refs.form3.validate((valid) => {
            if (valid) {
              if (this.isAdd) {
                this.formData3.uuid = uuidv4()
                this.$emit('saveData', this.formData3)
                this.$emit('update:ownerVisible', false)
              } else {
                this.$emit('updateData', this.formData3)
                this.$emit('update:ownerVisible', false)
              }
            } else {
              console.log('表单3验证不通过')
            }
          })
          break
        case '自然人':
          _this.$refs.form4.validate((valid) => {
            if (valid) {
              if (this.isAdd) {
                this.formData4.uuid = uuidv4()
                this.$emit('saveData', this.formData4)
                this.$emit('update:ownerVisible', false)
              } else {
                this.$emit('updateData', this.formData4)
                this.$emit('update:ownerVisible', false)
              }
            } else {
              console.log('表单4验证不通过')
            }
          })
          break
        case '未成年人':
          _this.$refs.form5.validate((valid) => {
            if (valid) {
              if (this.isAdd) {
                this.formData5.uuid = uuidv4()
                this.$emit('saveData', this.formData5)
                this.$emit('update:ownerVisible', false)
              } else {
                this.$emit('updateData', this.formData5)
                this.$emit('update:ownerVisible', false)
              }
            } else {
              console.log('表单5验证不通过')
            }
          })
          break
      }
    },
    cancel() {
      this.$emit('update:ownerVisible', false)
    },
    radioChange(e) {
      let category = e.target.value
      this.category = category
      if (!this.isAdd) {
        let currentFormData = JSON.parse(sessionStorage.getItem('currentFormData'))
        let uuid = currentFormData.uuid
        switch (category) {
          case '企业单位':
            this.formData1.uuid = uuid
            break
          case '事业单位':
            this.formData2.uuid = uuid
            break
          case '分公司':
            this.formData3.uuid = uuid
            break
          case '自然人':
            this.formData4.uuid = uuid
            break
          case '未成年人':
            this.formData5.uuid = uuid
            break
        }
      }
    }
  },
  watch: {
    // 计算成立时间是否超过三个月
    'formData1.companyFoundDate'(date) {
      if (date) {
        let currentDate = moment().format('YYYY-MM-DD') //当前时间
        const diff = moment(currentDate).diff(moment(date), 'months')
        diff < 3 ? (this.lt3Month = true) : (this.lt3Month = false)
      }
    },
    imagesArr: {
      handler(images) {
        let res = images.reduce((current, next) => {
          if (next.url) {
            current.push(next.url)
          }
          return current
        }, [])
        this.formData1.technicianCertified = res
        this.$nextTick(() => {
          this.$refs.form1.clearValidate('technicianCertified')
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.ownerInfo {
  color: #333;
  /deep/ .ant-calendar-picker {
    width: 340px !important;
  }
  ::v-deep .ant-modal-content {
    .ant-modal-body {
      .ant-form-item {
        display: flex;
      }
      .ant-form {
        .ant-form-item {
          .cr-text-line {
            text-decoration: underline;
          }
          .ant-form-item-children {
            display: flex;
            align-items: flex-end;
            .cr-sample {
              position: relative;
              display: inline-block;
              width: 160px;
              height: 120px;
              border-radius: 2px;
              border: 1px solid #eeeeee;
              padding: 4px;
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
              .cr-sams {
                border-radius: 0px 2px 0px 0px;
                position: absolute;
                top: 0;
                right: 0;
                width: 52px;
                height: 22px;
                line-height: 22px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}
/deep/.ant-form-item-with-help {
  margin-bottom: 19px;
}
.tech-wrapper {
  display: flex;
  .img-wrapper {
    width: 160px;
    flex-shrink: 0;
  }
}
</style>
